// extracted by mini-css-extract-plugin
export default {"moviePosterImage":"movie-poster_moviePosterImage__28I_w"};